import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import React from "react";

const { useStore, Provider } = createContextStore({
  height: 0,
  shouldKeepTopNavVisible: false,
  bannerHeight: 0,
  isBannerInView: false,
});

export const useTopOfPageContextStore = useStore;

export const TopOfPageContextStoreProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <Provider>{children}</Provider>;
};
